/** Tolerance for “at page bottom” (mobile toolbar resize, subpixel, iOS overscroll bounce). */
export const PAGE_BOTTOM_THRESHOLD_PX = 48;

/**
 * Whether the viewport bottom is within {@link PAGE_BOTTOM_THRESHOLD_PX} of the document end.
 * Used on Range Detail to ignore overscroll-bounce false scroll-up at end of page.
 *
 * @param {number} scrollY - Current window scroll position
 * @returns {boolean}
 */
export const isNearPageBottom = (scrollY) => {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return false;
  }

  const scrollHeight = document.documentElement?.scrollHeight ?? 0;
  const viewportBottom = scrollY + window.innerHeight;

  return viewportBottom >= scrollHeight - PAGE_BOTTOM_THRESHOLD_PX;
};
